/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */
import {
	BLOCK_TEMPLATES_SECTION,
	DATA_AND_CHARTS_SECTION,
	EMBED_SECTION,
	MEDIA_SECTION,
	OTHER_SECTION,
	RECOMMENDED_SECTION,
	ROVO_SECTION,
	STRUCTURE_SECTION,
	TABLE_MENU_ITEM,
	TEXT_FORMATTING_SECTION,
} from './keys';

export const QUICK_INSERT_MENU_RANK: {
	readonly 'quick-insert-block-templates-section': 7;
	readonly 'quick-insert-data-and-charts-section': 6;
	readonly 'quick-insert-embed-section': 3;
	readonly 'quick-insert-media-section': 2;
	readonly 'quick-insert-other-section': 8;
	readonly 'quick-insert-recommended-section': 0;
	readonly 'quick-insert-rovo-section': 5;
	readonly 'quick-insert-structure-section': 1;
	readonly 'quick-insert-text-formatting-section': 4;
} = {
	[RECOMMENDED_SECTION.key]: 0,
	[STRUCTURE_SECTION.key]: 1,
	[MEDIA_SECTION.key]: 2,
	[EMBED_SECTION.key]: 3,
	[TEXT_FORMATTING_SECTION.key]: 4,
	[ROVO_SECTION.key]: 5,
	[DATA_AND_CHARTS_SECTION.key]: 6,
	[BLOCK_TEMPLATES_SECTION.key]: 7,
	[OTHER_SECTION.key]: 8,
} as const;

export const QUICK_INSERT_STRUCTURE_SECTION_RANK: {
	readonly 'quick-insert-table-menu-item': 600;
} = {
	[TABLE_MENU_ITEM.key]: 600,
} as const;
